import { useAuth } from "../contexts/AuthContext";
import Dashboard from "../dashboards/Dashboard";
import { MessageType } from "../enums/messageType";
import JwtHelperService from "../services/jwtHelperService";
import LoggingService from "../services/loggingService";
import LoginRedirect from "./LoginRedirect";
import ExternalLoginIdp from "./ExternalLoginIdp";
import { IdentityProvider } from "../enums/identityProvider";

function Login() {

  const auth = useAuth();
  
  let tokenToCheck: string | null = null;
  const identityProvider = sessionStorage.getItem("IdentityProvider") as IdentityProvider;
  
  if (identityProvider === IdentityProvider.PI) {
    tokenToCheck = sessionStorage.getItem("PI-X-Auth-Token");
  } else {
    tokenToCheck = auth.userToken || null;
  }
  
  if (!tokenToCheck) {  
    LoggingService.log(LoggingService.isLoggingEnabled() ? `Login - Redirecting user to login screen as token does not exist` : '', MessageType.Info);
    return <LoginRedirect isTokenExpired ="false"/>
  }
  else
  {
    const decodedJwt = JwtHelperService.parseJwt(tokenToCheck);
  
    if (decodedJwt != null && decodedJwt.exp * 1000 < Date.now()) {
      LoggingService.log(LoggingService.isLoggingEnabled() ? `Login - Token expired - routing to ExternalLoginIdp` : '', MessageType.Info);
      return <ExternalLoginIdp />
    }

    LoggingService.log(LoggingService.isLoggingEnabled() ? `Login - Redirecting user to dashboard` : '', MessageType.Info);
    return <Dashboard />
  }
}

export default Login;